import _ from 'lodash';
import {list} from './config.js';
import {store, network} from './stores.js';
import storage from './storage.js';

console.debug((new Date).getFullYear() + ' (c) Ilyin Aleksey <alksily[at]outlook[dot]com>');

Object.defineProperty(String.prototype, 'capitalize', {
    value: function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    },
    enumerable: false
});

export const put_item = () => {
    let id, item, buf, el;

    const $cart = store('cart-items', '', '[]').get();

    if ((buf = storage.getItemAndRemove('calc-edit')) !== null) {
        id = +buf;
        item = $cart.find((el) => el.idTovar === id);
        document.body.dispatchEvent(new CustomEvent('item', {detail: item}));

        return [id, item];
    }

    if ((el = storage.getItemAndRemove('axis-edit')) !== null) {
        el = JSON.parse(el);
        id = +el.idTovar;
        item = _.merge({}, network.item, {
            idTovar: el.idTovar,
            title: el.name,
            comment: el.artikul,
            price: {
                rozn: el.summaRozn,
                opt: el.summaDil,
                sebest: el.sebestoim,
            },
            quantity: el.kolvo,
        });
        document.body.dispatchEvent(new CustomEvent('item', {detail: item}));

        return [id, item];
    }

    return [null, null];
};

export const findLinkByParts = (list, string) => {
    const $user = store('credential', 'getAuth').get();
    let b = 0, link = '';

    string = string.toLowerCase();

    list.forEach((item) => {
        let t = 0,
            title = item.title.toLowerCase(),
            calc = item.calc.toLowerCase(),
            alt = (item?.alt?.[$user.idSklad] ?? false);

        let product_name = string;
        if (alt) {
            product_name = product_name.replace(alt.toLowerCase(), title).toLowerCase()
        }

        title.split(' ').forEach((part) => {
            t += part.length >= 2 && product_name.includes(part) ? 1 : 0;
        });
        calc.split(' ').forEach((part) => {
            t += part.length >= 2 && product_name.includes(part) ? 1 : 0;
        });

        product_name.split(' ').forEach((part) => {
            t += part.length >= 2 && calc.includes(part) ? 1 : 0;
        })

        if (product_name.toLowerCase().startsWith(item.calc.toLowerCase())) {
            t += 10;
        }

        // Ноль совпадений нельзя считать успехом: иначе ссылкой становится
        // последний калькулятор в списке — «Доставка».
        if (t > 0 && t >= b) {
            b = t;
            link = item.link;
        }
    })

    return link;
};

export const parse_zayavka = async (nomer, nomerStr, vid = 16) => {
    console.debug('Parse zayavka', {nomer, nomerStr, vid});

    let recipient = {id: 0, nomDoc: -1, nomDocStr: '', fio: '', tel: '', email: '', address: '', note: '', markup_percent: 0, discount_percent: 0},
        items = [];

    (await network.get('getZayavka', {nomer, nomerStr, vid})).map((el) => {
        recipient.id = parseInt(el.idKontakt);
        recipient.nomDoc = nomer;
        recipient.nomDocStr = nomerStr;
        recipient.fio = el.nameKontakt;
        recipient.address = el.adresKontakt;
        recipient.email = el.other1Kontakt;
        recipient.tel = el.telefonKontakt;
        recipient.comment = el.komment;
        recipient.note = el.dopInfo;
        recipient.summaOpl = parseFloat(el.summaOpl);
        recipient.tv = parseInt(el.idTV);

        // ищем chutzpah
        if (el.dopInfo.includes('chutzpah:')) {
            let parts = el.dopInfo.split('|');
            let newParts = [];

            for (let part of parts) {
                if (part.startsWith('chutzpah:')) {
                    let [markup, discount] = part.replace('chutzpah:', '').split(':');
                    recipient.markup_percent = Math.max(0, parseFloat(markup));
                    recipient.discount_percent = Math.max(0, parseInt(discount));
                } else if (part.trim().length) {
                    newParts.push(part);
                }
            }

            recipient.note = newParts.join('|').trim();
        }

        switch (true) {
            case el.nameZvena.toLowerCase().includes('доставка'): {
                items.push({
                    idTovar: parseInt(el.idTovar),
                    type: 'доставка',
                    name: el.fullDisplayPath,
                    subname: el.tovarName,
                    title: el.fullDisplayPath,
                    params: {ind1: el.ind1, ind2: el.ind2, ind3: el.ind3, ind4: '', ind5: ''},
                    price: {rozn: el.summa, opt: el.summa, sebest: el.summa},
                    quantity: parseInt(el.kolvo),
                    materials: {},
                })

                break;
            }
            case el.tovarName.toLowerCase().includes('доставка'): {
                items.push({
                    idTovar: parseInt(el.idTovar),
                    type: 'доставка',
                    name: 'Доставка',
                    subname: '',
                    title: 'Доставка',
                    params: {ind1: el.ind1, ind2: el.ind2, ind3: el.ind3, ind4: '', ind5: ''},
                    price: {rozn: el.summa, opt: el.summa, sebest: el.summa},
                    quantity: parseInt(el.kolvo),
                    materials: {},
                })

                break;
            }
            case el.tovarName.toLowerCase().includes('монтаж'): {
                items.push({
                    idTovar: parseInt(el.idTovar),
                    type: 'монтаж',
                    name: el.tovarName + (el.artikul ? ' ('+el.artikul+')' : ''),
                    subname: '',
                    title: el.tovarName,
                    params: {ind1: el.ind1, ind2: el.ind2, ind3: el.ind3, ind4: '', ind5: ''},
                    price: {rozn: el.summa, opt: el.summa, sebest: el.summa},
                    quantity: parseInt(el.kolvo),
                    materials: {},
                });
                break;
            }
            case el.tovarName.toLowerCase().includes('дверь'):
            case el.tovarName.toLowerCase().includes('комплект '):
            case el.tovarName.toLowerCase().includes('пеналы и перегородки'): {
                items.push({
                    idTovar: parseInt(el.idTovar),
                    type: el.ind2,
                    name: 'Комплект',
                    subname: '',
                    title: el.tovarName,
                    comment: el.artikul,
                    params: {ind1: el.ind1, ind2: el.ind2, ind3: el.ind3, ind4: '', ind5: ''},
                    price: {rozn: el.summa, opt: el.summa, sebest: el.summa},
                    quantity: parseInt(el.kolvo),
                    materials: {},
                });
                break;
            }
            case el.tovarName.toLowerCase().includes('фурнитура'): {
                items.push({
                    idTovar: parseInt(el.idTovar),
                    type: 'фурнитура',
                    name: 'Фурнитура',
                    subname: '',
                    title: el.tovarName,
                    params: {ind1: el.ind1, ind2: el.ind2, ind3: el.ind3, ind4: '', ind5: ''},
                    price: {rozn: el.summa, opt: el.summa, sebest: el.summa},
                    quantity: parseInt(el.kolvo),
                    materials: {},
                });
                break;
            }
            case el.tovarName.toLowerCase().includes('услуги'): {
                items.push({
                    idTovar: parseInt(el.idTovar),
                    type: 'услуги',
                    name: el.tovarName + (el.artikul ? ' ('+el.artikul+')' : ''),
                    subname: '',
                    title: el.tovarName,
                    params: {ind1: el.ind1, ind2: el.ind2, ind3: el.ind3, ind4: '', ind5: ''},
                    price: {rozn: el.summa, opt: el.summa, sebest: el.summa},
                    quantity: parseInt(el.kolvo),
                    materials: {},
                });
                break;
            }
            default: {
                items.push({
                    idTovar: parseInt(el.idTovar),
                    type: el.fullDisplayPath.toLowerCase().replaceAll(' ', '-'),
                    calc: el?.calc ?? '',
                    name: el.fullDisplayPath,
                    subname: el.tovarName.replace(el.fullDisplayPath, '').trim(),
                    title: el.tovarName,
                    comment: el.artikul,
                    params: {ind1: el.ind1, ind2: el.ind2, ind3: el.ind3, ind4: '', ind5: ''},
                    price: {rozn: el.summa / el.kolvo, opt: el.opt_price , sebest: el.sebestomost },
                    quantity: parseInt(el.kolvo),
                    materials: {},
                });
            }
        }
    });

    // для важных переговоров
    if (APP_TYPE === 'profile-doors') {
        (await network.get('getKomplekt', {nomer, vid})).map((el) => {
            let idIzdelie = parseInt(el.idIzdelie),
                item = items.find((el) => el.idTovar === idIzdelie);

            item.subname += (item.subname ? '; ' : '') + el.tovarName + ' &times ' + parseInt(el.kolvo) + (+el.procent ? ' ' + el.procent + '%' : '');
        })
    }

    return {recipient, items};
}

export const encode = (str) => btoa(unescape(encodeURIComponent(str)));
export const decode = (str) => decodeURIComponent(escape(atob(str)));

export const format_price = (number) => {
    return (number * 1).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2,});
}

_.mixin({
    'sortMaterials': function (object, field = 'order') {
        return _.sortBy(_.map(object, (i, k) => {
            i.title = k;
            return i;
        }), [field]);
    }
});

window.onmessage = (e) => {
    if (e.data && typeof e.data === 'string' && e.data.includes('put_item::')) {
        let json = e.data.split('::')[1];
        let data = JSON.parse(json);
        let link = data?.calc?.trim()?.length ? data.calc : findLinkByParts(list, data.name || '');

        // Без своего калькулятора строку не открываем. Иначе «Монтаж» попадает
        // в редактирование «Доставки» и сохранение затирает карточку материала.
        if (!link) {
            return;
        }

        storage.setItem('axis-edit', json);
        location.href = '/calc/' + link;
    }
};

// default empty query list
location.query = {};

// build query params
window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    location.query[key] = value;
});

window.getWidgetCode = (axis = false) => {
    let credential = storage.getItem('credential');

    if (credential !== null) {
        console.log('Use this link');
        console.log(location.origin + '/?credential=' + encode(credential) + (axis ? '&axis=true' : ''));
        console.log('OR');
        console.log('Use this code');
        console.log("<script>\n" +
            "    const\n" +
            "        calc_class = 'btn btn-primary calc-axis', // invoke btn class string\n" +
            "        calc_style = 'color: red; padding: 20px 40px;', // invoke btn style string\n" +
            "        calc_css = '', // path external css file\n" +
            "        calc_text = 'Launch app', // invoke btn text\n" +
            "        calc_exist_btn = null, // selector exists btn in html\n" +
            "        calc_credential = '" + encode(credential) + "', // credential\n" +
            "        calc_width = '900px', // modal window\n" +
            "        calc_height = '100%', // modal window\n" +
            "        calc_id = 'calculator', // id tag script\n" +
            "        calc_host = '" + location.origin + "', // app address\n" +
            "        calc_redirect = '/dashboard' // open page\n" +
            "    ;\n" +
            "</script>\n" +
            "<script id=\"calculator\" src=\"" + location.origin + "/build/script.js?_=" + Date.now() + "\"></script>");

        return true;
    }

    console.warn('User not found');

    return false;
};

window.getCredential = () => {
    let credential = storage.getItem('credential');

    if (credential !== null) {
        credential = JSON.parse(credential);

        if (credential.dbname) {
            console.log('Use this credentials');
            console.log(encode(JSON.stringify({
                dbname: credential.dbname,
                id: credential.id,
                idSklad: credential.idSklad,
                idkontr: credential.idkontr,
                name: credential.name,
                dostup: credential.dostup,
                tip: credential.tip,
                calcs: credential.calcs,
            })));

            return true;
        }

        console.warn('dbname is undefined, relogin with username and password');
    } else {
        console.warn('User not found');
    }
    return false;
}

const get_order_template = (nomer, contact, products) => {
    return `
        <b>Ваша заявка получена. Ожидайте звонка менеджера</b><br><br>
        <table style="width: 100%">
            <tr>
                <td style="width: 50%"><b>Номер заказа</b></th>
                <td>${nomer}</td>
            </tr>
            <tr>
                <td><b>Заказчик</b></th>
                <td>${contact?.name ?? ''}</td>
            </tr>
            <tr>
                <td><b>Телефон</b></th>
                <td>${contact?.tel ?? ''}</td>
            </tr>
            <tr>
                <td><b>E-Mail</b></th>
                <td>${contact?.email ?? ''}</td>
            </tr>
            <tr>
                <td><b>Адрес</b></th>
                <td>${contact?.address ?? ''}</td>
            </tr>
        </table>
        
        <br><br><br>
        
        <table style="width: 100%">
            <tdead>
                <tr>
                    <td><b>Название</b></th>
                    <td style="width: 10%; text-align: right;"><b>Кол-во</b></th>
                    <td style="width: 10%; text-align: right;"><b>Сумма</b></th>
                </tr>
            </thead>
        
            <tbody>
                ${
                    products.map(
                        (product) => `
                            <tr>
                                <td>${product.title}</td>
                                <td style="text-align: right;">${format_price(product.quantity, 0)}</td>
                                <td style="text-align: right;">${format_price(product.price.rozn * product.quantity)}</td>
                            </tr>
                        `
                    ).join('')
                }
            </tbody>
        
            <tfoot>
                <tr>
                    <td colspan="2"><b>Итого</b></td>
                    <td style="text-align: right;">${format_price(products.reduce((sum, product) => sum + (product.price.rozn * product.quantity), 0))}</td>
                </tr>
            </tfoot>
        </table>
    `.trim();
}

export const send_order_mail = (nomer, contact, products) => {
    return {
        mail_from: 'no-reply@u4et.ru',
        mail_from_name: 'Калькулятор',

        to: contact.email ? contact.email : contact.admin,
        bcc: contact.email && contact.email !== contact.admin ? contact.admin : null,

        subject: `Расчёт в калькуляторе #${nomer}`,
        body: get_order_template(nomer, contact, products),
        isHtml: true,
    }
}
